import { motion } from "framer-motion";
import styled from "styled-components";
import { QUERIES } from "../../constants";

export const Wrapper = styled.div`
  padding-top: 160px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr 1fr;
  gap: 10px;

  @media ${QUERIES.phoneAndSmaller} {
    /* grid-template-columns: revert;
    grid-template-rows: repeat(autofill, 1fr);
    padding-top: 20px;
    justify-items: center; */
    display: none;
  }
`;

export const CardWrapper = styled(motion.span)`
  display: block;
  clip-path: polygon(-100% 0, 200% 0, 200% 100%, -100% 100%);
  ${Wrapper} &:nth-child(2) {
    grid-column: 3 / 4;
    grid-row: 1 / 2;
  }
  ${Wrapper} &:nth-child(3) {
    grid-column: 2 / 3;
    grid-row: 2 / 3;
  }
  ${Wrapper} &:nth-child(4) {
    grid-column: 1 / 2;
    grid-row: 3 / 4;
  }
  ${Wrapper} &:nth-child(5) {
    grid-column: 2 / 3;
    grid-row: 3 / 4;
  }
  ${Wrapper} &:nth-child(6) {
    grid-column: 3 / 4;
    grid-row: 4 / 5;
  }

  @media ${QUERIES.phoneAndSmaller} {
    ${Wrapper} &:nth-child(1n) {
      grid-column: revert;
      grid-row: revert;
      margin-left: -26px;
      margin-right: -26px;
    }
  }
`;

export const ProcessTopRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const ProcessCard = styled(motion.div)`
  background-color: var(--color-dark-700);
  display: flex;
  height: 360px;
  width: 100%;
  flex-direction: column;
  justify-content: space-between;
  padding: 30px 20px;
  
  @media ${QUERIES.phoneAndSmaller}{
    /* margin-left: -16px; */
    margin-right: -16px;
  }
`;

export const ProcessTitle = styled.h4`
  color: var(--color-white);
  max-width: 16ch;
`;

export const ProcessSelector = styled(ProcessTitle)``;

export const ProcessExtract = styled.p`
  font-weight: 300;
  max-width: 32ch;
  color: var(--color-white);
`;

export const ProcessSummary = styled(ProcessTitle)`
  padding-top: 50px;
  max-width: 30ch;
  grid-column: 1 / 3;
  grid-row: 1 / 2;
  justify-self: center;

  @media ${QUERIES.phoneAndSmaller} {
    ${Wrapper} & {
      padding-top: 0px;
      grid-column: revert;
      grid-row: revert;
      justify-self: revert;
    }
  }
`;
